// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema). The
// fuller domain `PaymentProfileSchema` in `../schemas/index.ts` validates
// server-returned records; this schema validates in-flight form values.
import {z} from 'zod';

export const RecordSchema = z.object({
    customerId: z.string().min(1, 'Required'),
    name: z.string().min(1, 'Required'),
    billingProviderId: z.string().min(1, 'Required'),
    providerPaymentMethodId: z.string().min(1, 'Required'),
    status: z.string().min(1, 'Required'),
});
